// ══════════════════════════════════════════════════════════════════════════════
//  src/components/shared/Valoracion.jsx
//  LA VALORACION DE UN PROFESOR, PINTADA UNA SOLA VEZ
//
//  ── POR QUE UN COMPONENTE Y NO UNA LINEA EN CADA PANTALLA ───────────────────
//  Porque ya lo probamos al reves. El «⭐ 5.0» estaba escrito a mano en seis
//  sitios —rejilla de profesores, ficha, nomina en dos vistas, exportacion de
//  horarios y la pantalla del alumno— y los seis mentian de forma ligeramente
//  distinta: uno hacia `.toFixed(1)`, otro `t.rating || '5.0'`, otro
//  `?? 5.0`. Arreglar cinco y olvidar el sexto habria dejado una pantalla
//  diciendo que un profesor tiene un 5,0 mientras las otras cinco dicen que es
//  nuevo — que es peor que el fallo original, porque ahora ademas se
//  contradicen.
//
//  ── EL DISEÑO ───────────────────────────────────────────────────────────────
//  Neumorfico, como pidio Rob. Hundida (`inset`) porque es una etiqueta de
//  estado, no un boton: no invita a pulsarla. Hereda las variables de color de
//  la pantalla que la contiene, asi que se ve bien tanto en el Command Center
//  como en el dashboard del alumno sin saber en cual esta.
// ══════════════════════════════════════════════════════════════════════════════

import { comoSeEnseña } from '../../valoraciones.js';
import './valoracion.css';

export default function Valoracion({ profesor, tamano = 'md', className = '' }) {
    const v = comoSeEnseña(profesor);

    return (
        <span
            className={`val-chip val-${v.tono} val-${tamano} ${className}`.trim()}
            // El `title` lleva el porque: «2 de 5 valoraciones, faltan 3». Sin
            // el, la pastilla dice «Evaluando» y no hay forma de saber cuanto
            // falta ni por que no sale el numero.
            title={v.titulo}
        >
            {v.modo === 'estrellas' ? (
                <>
                    <span className="val-star" aria-hidden="true">⭐</span>
                    <span className="val-num">{v.texto}</span>
                </>
            ) : (
                <span className="val-txt">{v.texto}</span>
            )}
        </span>
    );
}
